import { createSelector } from "reselect";
const getIntl = (state) => state.intl;
const getCurrency = createSelector(
  getIntl,
  (intl) => intl?.currency ?? void 0
);
const getCountry = createSelector(
  getIntl,
  (intl) => intl?.country ?? void 0
);
const getLocale = createSelector(
  getIntl,
  (intl) => intl?.locale ?? void 0
);
const getDistanceUnit = createSelector(
  getIntl,
  (intl) => intl?.distanceUnit ?? void 0
);
export {
  getCountry,
  getCurrency,
  getDistanceUnit,
  getIntl,
  getLocale
};
//# sourceMappingURL=selectors.js.map
